
import React from 'react'
import classNames from 'classnames'

const FormElementOption = ({ type = 'checkbox', selected, children, ...props }) => {
    return (
        <div
            className={classNames(
                'form-element--option',
                type === 'checkbox' ? 'option--checkbox' : 'option--radio',
                { 'form-element--selected': selected }
            )}
        >
            {children(props)}
        </div>
    )
}

export default FormElementOption
